import axios from "axios";
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {
    async renameAndDownloadFile(url, filename) {
      const fileResponse = await axios({
        url: url, //your url
        method: "GET",
        responseType: "blob", // important
      });
      url = window.URL.createObjectURL(new Blob([fileResponse.data]));
      const link = document.createElement("a");
      link.href = url;

      if (filename.split(".").pop() !== "pdf") {
        filename = filename + ".pdf";
      }
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    async downloadFileAndPreviewFile(url, openInNewTab = true) {
      const fileResponse = await axios({
        url: url, //your url
        method: "GET",
        responseType: "blob", // important
      });
      url = window.URL.createObjectURL(
        new Blob([fileResponse.data], { type: "application/pdf" })
      );
      if (openInNewTab) {
        window.open(url, "_blank");
      } else {
        return url;
      }
    },
  },
};
